export default __webpack_public_path__ + "static/media/mc_pulse_grey.eb2a9fc0.svg";